/* unplugin-vue-components disabled */import script from "./cover-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./cover-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./cover-dialog.vue?vue&type=style&index=0&id=2898fad8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2898fad8"]])

export default __exports__